<div class="outer-container">
    <img class="icon" [src]="modalData.icon">
    <div class="heading">{{modalData.heading | translate}}</div>
    <div class="content">{{modalData.content | translate}}</div>
    <div class="buttons-container">
        <button class="primary-button cursor-pointer" (click)="done()">{{modalData.btnText1 | translate}}</button>
    </div>
</div>
